<template>
  <div class="mobile_footer">
    <div class="footer_box">
      <img src="@/asset/mobile/footer/dark.png" alt="">
      <div class="content" style="border:none">
        <div class="footer_box_left">
          <p style="color:#2a82e4">品牌</p>
          <span><a href="https://www.enlightv.com">EnlightV澜景科技</a></span>
          <span><a href="https://www.hirender.com">Hirender</a></span>
          <span><a href="https://www.mhat.cn/sy">澜帽子</a></span>
          <span><a href="https://www.lanerp.com/index/enlightv.html">澜精灵ERP</a></span>
        </div>
        <div class="footer_box_rig">
          <p style="color:#2a82e4">联系我们</p>
          <span>咨询热线</span>
          <span>400-600-1196（7x24小时）</span>
          <span>公司直机</span>
          <span>010-53608556（工作日 9:00-18:00）</span>
<!--          <span>(工作日 9:00-18:00)</span>-->
        </div>

      </div>
      <div class="content" >
        <div class="footer_box_left">
          <p style="color:#2a82e4">解决方案</p>
          <span><router-link to="/projection">投影映射</router-link></span>
          <span><router-link to="/lightingDesign">灯光</router-link></span>
          <span><router-link to="/virtualProduction">虚拟制作xR/VP</router-link></span>
          <span><router-link to="/renderInteraction">实时渲染与交互</router-link></span>
        </div>
        <div class="footer_box_rig">
          <p style="color:#2a82e4">产品</p>
            <span><router-link to="/studio">Studio</router-link></span>
           <span><router-link to="/hecoosLighting">Lighting</router-link></span>
           <span><router-link to="/mediaServer">Server</router-link></span>
           <span><router-link to="/projectorbit">其他产品</router-link></span>

        </div>

      </div>
      <div class="footer">
        <p>京ICP备16030301号-3</p>
        <p>
          <span style="margin-right: 25px;">隐私政策</span>
          <span>服务协议</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '@/styles/mobile_xty.scss'
</style>
